/**
 * REVIVO Product Selector
 * Flavor tabs + bundle tiers + mix & match + frother add-on/free-gift.
 * Reads config from window.RevivoProduct[sectionId] (printed inline by revivo-product.liquid)
 * and wires real Shopify cart integration (POST /cart/add.js).
 *
 * Free frother at qualifying tiers is intentionally NOT added as a cart line here —
 * that's handled by the BOGOS gift app based on cart contents. This script only ever
 * adds the frother as a real paid line when the customer opts into the add-on.
 */
document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.rp-sec[data-section-id]');

  sections.forEach(function (root) {
    var sectionId = root.getAttribute('data-section-id');
    var config = (window.RevivoProduct || {})[sectionId];
    if (!config || !config.flavors || !config.flavors.length) return;

    var flavors = config.flavors;
    var tiers = config.tiers || [];
    if (!tiers.length) return;

    var flavorByKey = {};
    flavors.forEach(function (f) { flavorByKey[f.key] = f; });

    // ---- DOM refs ----
    var layout = root.querySelector('#rp-layout');
    var slider = root.querySelector('#rp-slider');
    var dotsEl = root.querySelector('#rp-dots');
    var nameEl = root.querySelector('#rp-name');
    var taglineEl = root.querySelector('#rp-tagline');
    var originEl = root.querySelector('#rp-origin');
    var chipsEl = root.querySelector('#rp-chips');
    var tierEls = root.querySelectorAll('.rp-bopt');
    var frotherBanner = root.querySelector('#rp-frother-banner');
    var frotherAddon = root.querySelector('#rp-frother-addon');
    var fadCheck = root.querySelector('#rp-fad-check');
    var fadToggle = root.querySelector('#rp-fad-toggle');
    var mixRow = root.querySelector('#rp-mix-row');
    var mixPanel = root.querySelector('#rp-mix-panel');
    var mixToggle = root.querySelector('#rp-mix-toggle');
    var mixNote = root.querySelector('#rp-mix-note');
    var priceBig = root.querySelector('#rp-price-big');
    var priceSub = root.querySelector('#rp-price-sub');
    var cta = root.querySelector('#rp-cta');
    var ctaError = root.querySelector('#rp-cta-error');
    var labWidgets = root.querySelector('#rp-lab-widgets');

    // ---- State ----
    var defaultTierIndex = 0;
    tiers.forEach(function (t, i) { if (t.default) defaultTierIndex = i; });

    var state = {
      flavor: flavors[0].key,
      tierIndex: defaultTierIndex,
      frotherAddon: false,
      mix: {}
    };

    function redistribute() {
      var tierQty = tiers[state.tierIndex].qty;
      state.mix = {};
      flavors.forEach(function (f) { state.mix[f.key] = 0; });
      state.mix[state.flavor] = tierQty;
    }
    redistribute();

    // ---- Flavor tabs ----
    root.querySelectorAll('.rp-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        state.flavor = tab.getAttribute('data-flavor');
        redistribute();
        render();
      });
    });

    // ---- Bundle tiles ----
    tierEls.forEach(function (el, i) {
      el.addEventListener('click', function () {
        state.tierIndex = i;
        state.frotherAddon = false;
        redistribute();
        render();
      });
    });

    // ---- Frother add-on toggle ----
    if (fadToggle) {
      fadToggle.addEventListener('click', function () {
        var tier = tiers[state.tierIndex];
        if (tier.grantsFreeFrother) return;
        state.frotherAddon = !state.frotherAddon;
        render();
      });
    }

    // ---- Mix & match ----
    if (mixRow && mixPanel) {
      mixRow.addEventListener('click', function () {
        var open = mixPanel.classList.contains('rp-open');
        mixPanel.classList.toggle('rp-open', !open);
        mixToggle.textContent = open ? 'Customize ↓' : 'Close ↑';
      });
    }
    root.querySelectorAll('.rp-mix-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var flavorKey = btn.getAttribute('data-flavor');
        var action = btn.getAttribute('data-action');
        var tierQty = tiers[state.tierIndex].qty;
        var total = Object.keys(state.mix).reduce(function (sum, k) { return sum + state.mix[k]; }, 0);

        if (action === 'inc') {
          if (total < tierQty) state.mix[flavorKey]++;
        } else {
          if (state.mix[flavorKey] > 0) state.mix[flavorKey]--;
        }
        render();
      });
    });

    // ---- Slider drag support ----
    if (slider) {
      var dragging = false, startX = 0, startScroll = 0;
      slider.addEventListener('mousedown', function (e) { dragging = true; startX = e.pageX - slider.offsetLeft; startScroll = slider.scrollLeft; });
      slider.addEventListener('mouseleave', function () { dragging = false; });
      slider.addEventListener('mouseup', function () { dragging = false; });
      slider.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        e.preventDefault();
        slider.scrollLeft = startScroll - (e.pageX - slider.offsetLeft - startX) * 1.5;
      });
      slider.addEventListener('touchstart', function (e) { startX = e.touches[0].pageX; startScroll = slider.scrollLeft; });
      slider.addEventListener('touchmove', function (e) { slider.scrollLeft = startScroll - (e.touches[0].pageX - startX) * 1.5; });
    }

    function goToSlide(n) {
      if (!slider) return;
      var visible = Array.prototype.filter.call(slider.querySelectorAll('img'), function (img) { return img.style.display !== 'none'; });
      if (visible[n]) slider.scrollLeft = visible[n].offsetLeft;
      if (dotsEl) {
        Array.prototype.forEach.call(dotsEl.querySelectorAll('.rp-dot'), function (d, i) {
          d.classList.toggle('rp-dot-active', i === n);
        });
      }
    }

    // ---- Render ----
    function render() {
      var flavor = flavorByKey[state.flavor];
      var tier = tiers[state.tierIndex];

      // Tabs
      root.querySelectorAll('.rp-tab').forEach(function (tab) {
        tab.classList.toggle('rp-tab-active', tab.getAttribute('data-flavor') === state.flavor);
      });
      if (layout) layout.style.setProperty('--tab-accent', flavor.accent || '#E04B3A');

      // Left panel copy
      if (nameEl) nameEl.textContent = flavor.name;
      if (taglineEl) taglineEl.textContent = flavor.tagline || '';
      if (originEl) originEl.textContent = flavor.origin || '';
      if (chipsEl) {
        chipsEl.innerHTML = (flavor.chips || []).filter(Boolean).map(function (c) {
          return '<span class="rp-chip">' + c + '</span>';
        }).join('');
      }

      // Slider
      if (slider) {
        var imgs = slider.querySelectorAll('img');
        var visIndex = 0;
        imgs.forEach(function (img) {
          img.style.display = img.getAttribute('data-flavor') === state.flavor ? 'block' : 'none';
        });
        slider.scrollLeft = 0;
        // Rebuild dots for this flavor's image count
        var count = Array.prototype.filter.call(imgs, function (img) { return img.getAttribute('data-flavor') === state.flavor; }).length;
        if (dotsEl) {
          dotsEl.innerHTML = '';
          for (var i = 0; i < count; i++) {
            var dot = document.createElement('span');
            dot.className = 'rp-dot' + (i === 0 ? ' rp-dot-active' : '');
            dot.addEventListener('click', (function (idx) { return function () { goToSlide(idx); }; })(i));
            dotsEl.appendChild(dot);
          }
        }
      }

      // Bundle tiles
      tierEls.forEach(function (el, i) {
        el.classList.toggle('rp-bopt-sel', i === state.tierIndex);
      });

      // Frother banner vs add-on
      if (frotherBanner) frotherBanner.classList.toggle('rp-visible', !!tier.grantsFreeFrother);
      if (frotherAddon) frotherAddon.classList.toggle('rp-hidden', !!tier.grantsFreeFrother);
      if (fadCheck) fadCheck.classList.toggle('rp-checked', state.frotherAddon && !tier.grantsFreeFrother);
      if (fadCheck) fadCheck.textContent = (state.frotherAddon && !tier.grantsFreeFrother) ? '✓' : '';

      // Mix panel
      if (mixPanel) {
        var total = 0;
        flavors.forEach(function (f) { total += (state.mix[f.key] || 0); });
        root.querySelectorAll('.rp-mix-num').forEach(function (numEl) {
          var key = numEl.getAttribute('data-count');
          numEl.textContent = state.mix[key] || 0;
        });
        root.querySelectorAll('.rp-mix-btn').forEach(function (btn) {
          var key = btn.getAttribute('data-flavor');
          var action = btn.getAttribute('data-action');
          if (action === 'inc') btn.disabled = total >= tier.qty;
          else btn.disabled = (state.mix[key] || 0) <= 0;
        });
        if (mixNote) {
          var remaining = tier.qty - total;
          if (remaining === 0) {
            var parts = flavors.filter(function (f) { return state.mix[f.key] > 0; })
              .map(function (f) { return state.mix[f.key] + ' ' + f.name; });
            mixNote.textContent = '✓ ' + parts.join(' + ') + ' = ' + tier.qty + ' bag' + (tier.qty > 1 ? 's' : '');
          } else if (remaining > 0) {
            mixNote.textContent = remaining + ' more to select';
          } else {
            mixNote.textContent = Math.abs(remaining) + ' too many — adjust your mix';
          }
        }
      }

      // Pricing
      var frotherCharge = (state.frotherAddon && !tier.grantsFreeFrother) ? (config.frother.addonPrice || 0) : 0;
      var total = tier.total + frotherCharge;
      if (priceBig) priceBig.textContent = '$' + total;
      if (priceSub) {
        var perBagLabel = tier.qty + ' bag' + (tier.qty > 1 ? 's' : '') + ' · $' + tier.pricePerBag + '/bag' + (tier.save > 0 ? ' · Save $' + tier.save : '');
        priceSub.textContent = perBagLabel;
      }
      if (cta) cta.textContent = 'Add to Cart — $' + total;

      if (ctaError) ctaError.classList.remove('rp-visible');

      // Lab-tested widget — show only the block matching the active flavor
      if (labWidgets) {
        labWidgets.querySelectorAll('[data-flavor]').forEach(function (w) {
          w.style.display = w.getAttribute('data-flavor') === state.flavor ? 'block' : 'none';
        });
      }
    }

    // ---- Add to Cart ----
    if (cta) {
      var cartNotification = document.querySelector('cart-notification');

      cta.addEventListener('click', function () {
        var tier = tiers[state.tierIndex];
        var total = 0;
        flavors.forEach(function (f) { total += (state.mix[f.key] || 0); });

        if (total !== tier.qty) {
          if (ctaError) {
            ctaError.textContent = 'Please select ' + (tier.qty - total) + ' more bag(s) in the mix above.';
            ctaError.classList.add('rp-visible');
          }
          return;
        }

        var items = [];
        flavors.forEach(function (f) {
          var qty = state.mix[f.key] || 0;
          if (qty > 0 && f.variantId) items.push({ id: parseInt(f.variantId, 10), quantity: qty });
        });
        if (state.frotherAddon && !tier.grantsFreeFrother && config.frother.variantId) {
          items.push({ id: parseInt(config.frother.variantId, 10), quantity: 1 });
        }

        if (!items.length) {
          if (ctaError) {
            ctaError.textContent = 'This section isn’t configured yet — link products to each flavor in the theme editor.';
            ctaError.classList.add('rp-visible');
          }
          return;
        }

        cta.disabled = true;
        var originalText = cta.textContent;
        cta.textContent = 'Adding...';

        var body = { items: items };
        if (cartNotification && typeof cartNotification.getSectionsToRender === 'function') {
          var sectionsToRequest = cartNotification.getSectionsToRender().map(function (s) { return s.id; });
          if (sectionsToRequest.length) {
            body.sections = sectionsToRequest;
            body.sections_url = window.location.pathname;
          }
        }

        var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';

        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (response) { return response.json().then(function (data) { return { ok: response.ok, data: data }; }); })
          .then(function (result) {
            if (!result.ok || result.data.status) {
              throw new Error(result.data.description || result.data.message || 'Cart add failed');
            }
            cta.textContent = 'Added!';

            // NOTE: publish/PUB_SUB_EVENTS are declared with `const`/`function` at the top
            // level of classic (non-module) scripts in theme.liquid. Function declarations
            // attach to `window`, but `const` does NOT — so `window.PUB_SUB_EVENTS` is
            // always undefined even though the bare identifier `PUB_SUB_EVENTS` resolves
            // fine via the shared script scope. Use bare identifiers here (matching
            // product-form.js) so this actually fires instead of being silently skipped.
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'revivo-product', cartData: result.data });
            }
            try {
              if (cartNotification) {
                var payload = result.data;
                if (!payload.key && payload.items && payload.items.length) payload.key = payload.items[0].key;
                cartNotification.renderContents(payload);
              }
            } catch (notifErr) {
              console.warn('Revivo Product: cart notification render failed', notifErr);
            }
          })
          .catch(function (err) {
            console.error('Revivo Product: cart add error', err);
            if (ctaError) {
              ctaError.textContent = err.message && err.message.length < 80 ? err.message : 'Something went wrong — please try again.';
              ctaError.classList.add('rp-visible');
            }
            cta.textContent = 'Error — Try Again';
          })
          .finally(function () {
            setTimeout(function () {
              cta.disabled = false;
              if (cta.textContent === 'Adding...') cta.textContent = originalText;
              render();
            }, 2200);
          });
      });
    }

    render();
  });
});
